import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Navigation from './Navigation';
import IconSmartGaming from './IconSmartGaming';

const Header = ({ isNavigationOpen, isAuthenticated, toggleNavigation, headerType, logout }) => {
  const [showShadow, setShadow] = useState(false);

  useEffect(() => {
    const headerHeight = headerRef.current.offsetHeight;

    function handleOnScroll(e) {
      const offsetTop = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
      setShadow(offsetTop > headerHeight / 2);
    }

    window.addEventListener('scroll', handleOnScroll);
    
    return function cleanup() {
      window.removeEventListener('scroll', handleOnScroll);
    }
  });

  const getHeaderBackgroundClass = (type, showShadow) => {
    if (showShadow) {
      return 'shadow bg-white';
    }

    switch (type) {
      case 'default':
        return 'bg-white';
      case 'transparent':
        return 'bg-transparent';
      default:
        return 'bg-white';
    };
  }

  const shouldBeFixedBlack = (type) => {
    return type === 'default'
      ? true
      : false;
  };

  const headerRef = React.createRef();

  return (
    <header 
      className={`sg-header fixed w-screen z-20 top-0 flex items-center justify-between flex-wrap px-6 py-3 ${ headerType === 'transparent' && !showShadow ? 'sg-header--gradient' : '' } ${ getHeaderBackgroundClass(headerType, showShadow) }`}
      ref={headerRef}
    >
      <div className="flex justify-center items-center flex-shrink-0 text-white">
        <Link to="/">
          <IconSmartGaming fill={shouldBeFixedBlack(headerType) || showShadow || isNavigationOpen ? '#000000' : '#FFFFFF'} width={44} />
        </Link>
      </div>
      <div className="mr-4 fixed right-0 z-50">
        <button onClick={toggleNavigation} className={`flex justify-center items-center hamburger ${!shouldBeFixedBlack(headerType) && !showShadow && !isNavigationOpen ? 'hamburger--white' : ''} hamburger--spin ${ isNavigationOpen ? 'is-active' : '' }`} type="button">
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </div>
      { isNavigationOpen && <Navigation isAuthenticated={isAuthenticated} onLogout={logout} /> }
    </header>
  );
};

export default Header;